import React from 'react';
import PropTypes from 'prop-types';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { GoEyeClosed } from 'react-icons/go';
import { IconContext } from 'react-icons';
import '../../styles/service.css';

function Service({ service, closeModal }) {
  return (
    <div className="service-mother-container">
      <div className="service-container" key={service.id} id="service-container">
        <nav>
          <GoEyeClosed
            onClick={closeModal}
            className="close-modal"
          />
        </nav>
        <h1 className="body-font">{service.name}</h1>
        <p className="body-font">
          Services with more than 5 year+ hands-on Experience in building
          and designing innovative software solution
        </p>
        <section className="service-offer-sec">
          {service.offers.map((offer) => (
            <table key={offer.id}>
              <tbody>
                <tr className="service-offer" id="service-offer">
                  <td>
                    <IconContext.Provider value={{ size: '1.5em', className: 'global-class-name service-icon' }}>
                      <IoMdCheckmarkCircleOutline />
                    </IconContext.Provider>
                  </td>
                  <td>
                    <p className="body-font">{offer}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          ))}
        </section>
      </div>
    </div>
  );
}

export default Service;

Service.propTypes = {
  service: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    offers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  closeModal: PropTypes.func.isRequired,
};
